import React from 'react';
import HeroSection from './components/HeroSection';
import SkillsVisualization from './components/SkillsVisualization';
import FeaturedProjects from './components/FeaturedProjects';
import GitHubActivity from './components/GitHubActivity';
import CallToAction from './components/CallToAction';

const HomePage = () => {
  return (
    <main className="bg-white text-slate-900">
  <HeroSection />
  <SkillsVisualization />
  <FeaturedProjects />
  <GitHubActivity />
  <CallToAction />
    </main>
  );
};

export default HomePage;
